module.exports = __webpack_public_path__ + "img/_4.cfa0a2fd.png";